import script from "./BlazeStarNova.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlazeStarNova.vue?vue&type=script&setup=true&lang=ts"

import "./BlazeStarNova.vue?vue&type=style&index=0&id=38247778&lang=less"

const __exports__ = script;

export default __exports__